import "./index.scss";

export const PageTitle = ({children}) => (
  <div className="pageTitle">
    <h1>{children}</h1>
  </div>
);
